import ColorByStatus from './ColorByStatus'

function GridOraculoApprovalStatus({ oraculo }) {

  const error = oraculo === '' || oraculo === null

  return <ColorByStatus error={error} message={oraculo || "Aprobación pendiente"} />
}

export default GridOraculoApprovalStatus
